import React, { Component } from "react";
import { connect } from "react-redux";

import { UserRoles } from "../../user/user.constants";
import { getCurrentUser, getCurrentUserRole } from "../../user/user.selectors";
import { getCombinedContent } from "../../content/content.selectors";
import * as contentActions from "../../content/content.actions";
import { ContentBlock, ContentSection, PageHeader } from "../components";

import { CampaignAdminBlock, CampaignAlertBlock } from "../../campaign/components";
import {
  InnerCircleListBlockAdmin,
  NewsListBlockAdmin,
  RulesListBlockAdmin
} from "../../content/components";
import { PrizesListBlock } from "../../prize/components";
import { ProductsListBlock, ScoreAdminBlock } from "../../product/components";

import { TotalSalesBlockAdmin, TotalSalesBlock } from "../../transaction/components";
import { UserListBlockAdmin, UserListContainer } from "../../user/components";

import { Localize } from "../../../locale/localization";

class AdminPage extends Component {
  renderSuperUserContent() {
    return (
      <ContentSection>
        <CampaignAdminBlock />
        <TotalSalesBlockAdmin />
        <ContentBlock title={Localize("prizes")}>
          <PrizesListBlock />
        </ContentBlock>
        <RulesListBlockAdmin />
        <ScoreAdminBlock />
        <ContentBlock title={Localize("packages")}>
          <ProductsListBlock />
        </ContentBlock>
        <NewsListBlockAdmin />
        <InnerCircleListBlockAdmin />
        <UserListBlockAdmin />
      </ContentSection>
    );
  }

  renderSalesManagerContent() {
    return (
      <ContentSection>
        <TotalSalesBlock />
        <UserListContainer />
      </ContentSection>
    );
  }

  renderRegionManagerContent() {
    return (
      <ContentSection>
        <TotalSalesBlock />
        <UserListContainer />
      </ContentSection>
    );
  }

  renderTeamLeaderContent() {
    return (
      <ContentSection>
        <TotalSalesBlock />
        <UserListContainer />
      </ContentSection>
    );
  }

  renderRoleContent(role) {
    switch (role) {
      case UserRoles.SUPERUSER:
        return this.renderSuperUserContent();
      case UserRoles.SALESMANAGER:
        return this.renderSalesManagerContent();
      case UserRoles.REGIONMANAGER:
        return this.renderRegionManagerContent();
      case UserRoles.TEAMLEADER:
        return this.renderTeamLeaderContent();
      default:
        return null;
    }
  }

  render() {
    const { currentUser, role } = this.props;
    return (
      <div>
        {currentUser.hasAccessToPrizeProgram && <CampaignAlertBlock />}
        <PageHeader title={Localize("root.admin")} />
        {this.renderRoleContent(role)}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const role = getCurrentUserRole(state);
  const content = getCombinedContent(state);

  return {
    currentUser,
    role,
    content
  };
};

const ConnectedAdminPage = connect(mapStateToProps, contentActions)(AdminPage);

export default ConnectedAdminPage;



// WEBPACK FOOTER //
// ./src/modules/pages/admin/AdminPage.js